module.exports = __webpack_public_path__ + "static/media/rolling.eb29cc41.svg";